/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// @flow

// Accepts either a plain string or a FormattableText { text } wrapper.
const predictionText = (value: mixed): string => {
  if (typeof value === 'string') {
    return value;
  }
  if (value && typeof value === 'object' && typeof value.text === 'string') {
    return value.text;
  }
  return '';
};

export default predictionText;
